function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,8.82a1.29,1.29,0,0,0-1.06.65,2.41,2.41,0,0,0-.36,1.35C7,12,8.32,13,9.17,13.59c7.7,5.23,5.77,5.63,11.61,1.43,1.28-.93,3.07-1.85,3.84-3a2.24,2.24,0,0,0,.15-2.64c-.56-.64-1.07-.57-1.93-.57H10C9.42,8.79,8.83,8.79,8.25,8.82Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,23.2h5.16a1.61,1.61,0,0,0,1.64-1.27,8.79,8.79,0,0,0,.07-1.36V13.45h0c-.28.27-.75.66-1.33,1.11-2.42,1.83-6.68,4.68-7.86,4.73s-5.44-2.9-7.81-4.73a14,14,0,0,1-1.33-1.11h0v7.12a7.7,7.7,0,0,0,.06,1.36A1.63,1.63,0,0,0,8.51,23.2Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8a8030ac.svg";
export { ForwardRef as ReactComponent };